import { Icons } from "../assets/assets";

export type PartnershipCard = {
  icon: string;
  title: string;
  items: string[];
};

export type PartnershipType = "associate" | "strategic" | "referral";

export const associatePartnershipCards: PartnershipCard[] = [
  {
    icon: Icons?.becomePatner.Associate_Partnership,
    title: "Benefits",
    items: [
      "A highly talented team of designers and developers will work on your project. You will experience client-centric services.",
      "All your work will be executed on priority.",
      "You will receive great discounts on hourly rates on all your projects. This is only offered to our associate projects.",
      "You can enjoy our amazing services as and when required.",
    ],
  },
  {
    icon: Icons?.becomePatner.Strategic_Partnership,
    title: "Eligibility",
    items: [
      "You must have a properly maintained infrastructure and development team at your end.",
      "You must have prior experience in the field of web and mobile development.",
      "You must be capable of closing business deals and managing projects.",
    ],
  },
  {
    icon: Icons?.becomePatner.Referral_Partnership,
    title: "Responsibilities",
    items: [
      "Need to have premises with proper infrastructure.",
      "Company credibility and experience in the field of mobile solutions.",
      "Ability and experience to drive sales and marketing initiatives and run campaigns.",
    ],
  },
];

export const strategicPartnershipCards: PartnershipCard[] = [
  {
    icon: Icons?.becomePatner.Associate_Partnership,
    title: "Benefits",
    items: [
      "No headaches of managing a team or overlooking project development or any technical aspects of the project.",
      "Focus is required only on bringing business and closing project deals.",
      "Extremely competitive pricing offered for projects to our strategic partners.",
      "Enjoy the high-end quality services of an extensively experienced design and development team without the physical pains of maintaining it.",
    ],
  },
  {
    icon: Icons?.becomePatner.Strategic_Partnership,
    title: "Eligibility",
    items: [
      "Required to have a talented in-house business and sales team.",
      "Required to have prior experience in dealing with clients and closing web and mobile business deals.",
      "The necessary establishment and infrastructure.",
      "Should be able to provide regular business.",
    ],
  },
  {
    icon: Icons?.becomePatner.Referral_Partnership,
    title: "Responsibilities",
    items: [
      "To enhance the reputation of our brand.",
      "To bring regular web design and mobile application development business.",
      "To pass on the complete project requirements to us.",
    ],
  },
];

export const referralPartnershipCards: PartnershipCard[] = [
  {
    icon: Icons?.becomePatner.Associate_Partnership,
    title: "Benefits",
    items: [
      "No complexities; all you need to do is to recommend us to the potential clients. Your job ends here.",
      "We work closing the deals. And then with our expert and experienced design and development teams, we successfully complete the project.",
      "Our top-notch service ensures that all your recommendations are well handled and thank you for recommending us.",
      "You receive commission in the form of credit on all your future projects.",
    ],
  },
  {
    icon: Icons?.becomePatner.Strategic_Partnership,
    title: "Eligibility",
    items: ["There is no eligibility for this partnership program."],
  },
  {
    icon: Icons?.becomePatner.Referral_Partnership,
    title: "Responsibilities",
    items: [
      "No responsibilities. Simply recommend trusted and potential clients to us and enjoy your rewards.",
    ],
  },
];
